import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetChallengeInsightProgressTimeInAppSummaryApplicationService } from '../../../core/application/services/challenge-insights/get-challenge-insight-progress-time-in-app-summary.application-service';
import { ChallengeInsightProgressTimeInAppSummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-time-in-app.aggregate-root';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';

export class GetChallengeInsightProgressTimeInAppSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetChallengeInsightProgressTimeInAppSummaryApplicationService
  ) {}
  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<ChallengeInsightProgressTimeInAppSummaryAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
